import { Alert, Form, Input, message, Modal, Select, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { authFetch } from '../../../../common/request/authFetch';
import { customRequest } from '../../../../common/request/customRequest';
import { STATUS_CODE } from '../../../../common/constants/statusCode';
import { useAuth } from '../../../../store/AuthContext/AuthContext';

export const GuestAddModal = (
	props : {
		onFinish: any,
		}
	) => {

	const [errorMessage, setErrorMessage] = useState<any>(null);
	const { t } = useTranslation();
	const [form] = Form.useForm();

	const { projectGroup } = useAuth();

	const onFormFinish = async (values: any) => {
		const data = {
			...values,
			roles: values.roles,
			status: 'CREATED'			
		};


		const response = await customRequest(`${process.env.REACT_APP_API}/config/guest`, { method: 'POST', data: data });
		if (response?.statusCode === STATUS_CODE.BAD_REQUEST) {			
			setErrorMessage(response.message)
		} else {
			props.onFinish();
		}
	};

  return (
		<Modal visible={true} onOk={() => form.submit()} onCancel={props.onFinish} afterClose={form.resetFields}>
			<h2>Nuevo Usuario</h2>
			<Form layout='vertical' form={form} onFinish={onFormFinish}>
				<Form.Item label={t('dictionary.email')} name='guestEmail' rules={[{ required: true, type: 'email' }]}>
					<Input />
				</Form.Item>				
				<Form.Item label={'Proyecto'} name='project' initialValue={projectGroup.project} rules={[{ required: true }]}>
					<Input disabled/>				
				</Form.Item>				
			</Form>
			{errorMessage && <Alert
				type='error'
				message={errorMessage}
				banner
			/>
			}
		</Modal>
	)
}
